export default {
	properties: [
		{
			text: 'Nombre',
			key: 'name',
			type: 'text',
			value: '',
			is_title: true,
		},
	],
	singular_model_name_spanish: 'Metodo de Pago',
	plural_model_name_spanish: 'Metodos de Pago',
	create_model_name_spanish: 'Nuevo',
	text_delete: 'el',
}